/**
 * Labstep
 */

import type { APICallOptions } from 'labstep-web/models';
import { Experiment } from 'labstep-web/models/experiment.model';
import { File } from 'labstep-web/models/file.model';
import type { Protocol } from 'labstep-web/models/protocol.model';
import { updateEntity } from 'labstep-web/state/actions/entity';
import store from 'labstep-web/state/store';

export const updateFile = (
  entity: Experiment | Protocol,
  file: File,
  options?: APICallOptions,
): void => {
  let body: any = {};
  if (entity instanceof Experiment) {
    body = { experiment_id: entity.id };
  } else {
    body = { protocol_id: entity.id };
  }
  store.dispatch(
    updateEntity(File.entityName, file.id, body, options),
  );
};
